import React, { useState, useEffect, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import urls from "../../constants";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import ContactDetails from "./ContactDetails";
import { getStorageData } from "../../utils/Validate";

// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
  ></input>
));
// datepicker end
const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};
const ProjectDetails = (props) => {
  const {
    customerdata,
    distributordata,
    projectsegment,
    projectstatus,
    countrydata,
    ContractorOpen,
    customertypedata,
    MEPlistData,
    ConAddToList,
    HandleMEPChange,
    addtoListMEP,
    addMEP,
    ConDeleteToList,
    deleteContact,
    setContactShow,
    EditContact,
    contact,
    formValues,
    HandleFormChange,
    HandleDropDownChange,
    prjSegment,
    prjStatus,
    prjmepCust,
    prjmainCust,
    prjDesignCust,
    prjSuperCust,
    prjClientCust,
    prjDistributorCust,
    prjCountry,
    prjStartDate,
    setprjStartDate,
    prjEndDate,
    setprjEndDate,
    formErrors,
    HandleFormSubmit,
    ClearFormValues,
    setprjSegment,
    setprjStatus,
    setprjmepCust,
    setprjMainCust,
    setprjDesignCust,
    setprjSuperCust,
    setprjClientCust,
    setprjDistCust,
    setprjCountry,
    contractorValues,
    setaddtoListMEP,
    setaddMEP,
  } = props;
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [customerData, setCustomerData] = useState([]);

  const [mepPrjCustomerDrp, setMEPPrjCustomerdrp] = useState([]);
  const [mepCustomerDrp, setMEPCustomerdrp] = useState([]);
  const [mainCustomerDrp, setMainCustomerdrp] = useState([]);
  const [designCustomerDrp, setDesignCustomerdrp] = useState([]);
  const [superCustomerDrp, setSuperCustomerdrp] = useState([]);
  const [clientCustomerDrp, setClientCustomerdrp] = useState([]);

  useEffect(() => {
    setCustomerData(customerdata);
  }, [customerdata]);

  useEffect(() => {
    setCustomerData(customerdata?.filter(item => item?.distributorId === formValues?.distributorId))
  }, [formValues?.distributorId,customerdata])

  useEffect(() => {
    const getCustomerData = () => {
      if (customerData) {
        const MEPcusttype = customerData.filter((item) =>
          item.type.includes(urls.MEP_CUSTOMER)
        );

        setMEPCustomerdrp(MEPcusttype);
        setMEPPrjCustomerdrp(MEPcusttype);

        const Maincusttype = customerData.filter((item) =>
          item.type.includes(urls.MAIN_CUSTOMER)
        );
        setMainCustomerdrp(Maincusttype);

        const Designcusttype = customerData.filter((item) =>
          item.type.includes(urls.DESIGN_CONSULTANT_CUSTOMER)
        );
        setDesignCustomerdrp(Designcusttype);

        const Supercusttype = customerData.filter((item) =>
          item.type.includes(urls.SUPER_VISION_CONSULTANT_CUSTOMER)
        );
        setSuperCustomerdrp(Supercusttype);

        const Clientcusttype = customerData.filter((item) =>
          item.type.includes(urls.CLIENT_CUSTOMER)
        );
        setClientCustomerdrp(Clientcusttype);
      }
    };
    getCustomerData();
  }, [customerData]);

  useEffect(() => {
    if (MEPlistData?.length > 0) {
      const MEPcusttype = MEPlistData?.filter((item) =>
        item.type.includes(urls.MEP_CUSTOMER)
      );
      const latestCustomer = MEPcusttype?.find(
        (obj) => obj?.id == contractorValues?.value
      );
      if (latestCustomer) {
        setaddtoListMEP([
          ...addtoListMEP,
          {
            value: latestCustomer?.id,
            label: latestCustomer?.customerName,
          },
        ]);
      }
      setMEPCustomerdrp(MEPcusttype);
    }
  }, [MEPlistData]);

  useEffect(() => {
    let checkList = customerData;
    if (MEPlistData?.length > 0) checkList = MEPlistData;
    if (checkList.length > 0) {
      checkList = checkList?.filter((item) =>
        item.type.includes(urls.MEP_CUSTOMER)
      );
      const MEPcusttype = checkList?.filter(
        (item) =>
          !addtoListMEP
            ?.map((element, index) => {
              return element.value;
            })
            .includes(item.id)
      );

      setMEPCustomerdrp(MEPcusttype);
    }
  }, [addtoListMEP]);

  return (
    <section className="project-add-sec">
      <div className="row">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="card header-card">
            <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <div className="card general-info-card mb-2">
                      <div className="card-header">
                        <h2>General Information</h2>
                      </div>
                      <div className="card-body">
                        <div>
                          {formErrors?.projecterr && (
                            <p className="form-error">{formErrors?.projecterr}</p>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-12 mb-2">
                            <div>
                              <label>
                                Project Name <span className="mandatory">*</span>
                              </label>
                              <input
                                className="form-control"
                                name="projectName"
                                value={formValues?.projectName}
                                onChange={HandleFormChange}
                                type="text"
                                placeholder={PlaceHolder.PROJECT_NAME}
                              ></input>
                              {formErrors?.projectName && (
                                <p className="form-error">{formErrors?.projectName}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Distributor <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                placeHolder={PlaceHolder.SELECT_DISTRIBUTOR}
                                pageName="project"
                                dpDownName="distributor"
                                stateData={distributordata}
                                controlName="distributordrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "distributorId");
                                }}
                                value={prjDistributorCust}
                                valueId={formValues?.distributorId}
                                setState={setprjDistCust}
                                isDisabled={getStorageData()?.userType === 2 ? true : false}
                              />
                              {formErrors?.distributorId && (
                                <p className="form-error">{formErrors?.distributorId}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Country <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                placeHolder={PlaceHolder.SELECT_COUNTRY}
                                pageName="project"
                                dpDownName="country"
                                stateData={countrydata}
                                controlName="countrydrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "countryId");
                                }}
                                value={prjCountry}
                                valueId={formValues?.countryId}
                                setState={setprjCountry}
                                isDisabled={true}
                              />
                              {formErrors?.countryId && (
                                <p className="form-error">{formErrors?.countryId}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Client
                              </label>
                              <DropDownComponent
                                placeHolder={formValues?.distributorId ? PlaceHolder.SELECT_CLIENT : PlaceHolder.SHOULD_CHOOSE_FIELD("client")}
                                pageName="project"
                                dpDownName="customer"
                                stateData={clientCustomerDrp}
                                controlName="Clientcustomerdrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "clientId");
                                }}
                                value={prjClientCust}
                                valueId={formValues?.clientId}
                                setState={setprjClientCust}
                                isDisabled={formValues?.distributorId ? false : true}
                              />
                              {formErrors?.clientId && (
                                <p className="form-error">{formErrors?.clientId}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                MEP Contractor
                              </label>
                              <DropDownComponent
                                placeHolder={formValues?.distributorId ? PlaceHolder.SELECT_MEP_CUSTOMER : PlaceHolder.SHOULD_CHOOSE_FIELD("mep contractor")}
                                pageName="project"
                                dpDownName="customer"
                                stateData={mepPrjCustomerDrp}
                                controlName="MEPPrjcustomerdrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "mepContractorId");
                                }}
                                value={prjmepCust}
                                valueId={formValues?.mepContractorId}
                                setState={setprjmepCust}
                                isDisabled={formValues?.distributorId ? false : true}
                              />
                              {formErrors?.mepContractorId && (
                                <p className="form-error">
                                  {formErrors?.mepContractorId}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Design Consultant
                              </label>
                              <DropDownComponent
                                placeHolder={formValues?.distributorId ? PlaceHolder.SELECT_DESIGN_CONSULTANT : PlaceHolder.SHOULD_CHOOSE_FIELD("design consultant")}
                                pageName="project"
                                dpDownName="customer"
                                stateData={designCustomerDrp}
                                controlName="Designcustomerdrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "designConultantId");
                                }}
                                value={prjDesignCust}
                                valueId={formValues?.designConultantId}
                                setState={setprjDesignCust}
                                isDisabled={formValues?.distributorId ? false : true}
                              />
                              {formErrors?.designConultantId && (
                                <p className="form-error">
                                  {formErrors?.designConultantId}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Main Contractor <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                placeHolder={formValues?.distributorId ? PlaceHolder.SELECT_MAIN_CUSTOMER : PlaceHolder.SHOULD_CHOOSE_FIELD("main contractor")}
                                pageName="project"
                                dpDownName="customer"
                                stateData={mainCustomerDrp}
                                controlName="Maincustomerdrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "mainContractorId");
                                }}
                                value={prjmainCust}
                                valueId={formValues?.mainContractorId}
                                setState={setprjMainCust}
                                isDisabled={formValues?.distributorId ? false : true}
                              />
                              {formErrors?.mainContractorId && (
                                <p className="form-error">
                                  {formErrors?.mainContractorId}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Project Segment <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                placeHolder={PlaceHolder.SELECT_SEGMENT}
                                pageName="project"
                                dpDownName="projectsegment"
                                stateData={projectsegment}
                                controlName="prjSegdrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "projectSegmentId");
                                }}
                                value={prjSegment}
                                valueId={formValues?.projectSegmentId}
                                setState={setprjSegment}
                              />
                              {formErrors?.projectSegmentId && (
                                <p className="form-error">
                                  {formErrors?.projectSegmentId}
                                </p>
                              )}
                            </div>
                          </div>
                          {/* <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                              <div>
                                                  <label>Project Type <span className='mandatory'>*</span></label>
                                                  <DropDownComponent placeHolder={PlaceHolder.SELECT_STATUS} pageName="project" dpDownName="projectstatus" stateData={projectstatus} controlName="prjStadrp" handleChange={(e) => { HandleDropDownChange(e, "projectStatusId") }} value={prjStatus} valueId={formValues?.projectStatusId} setState={setprjStatus} />
                                                  {formErrors?.projectStatusId && <p className="form-error">{formErrors?.projectStatusId}</p>}
                                              </div>
                                          </div> */}
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Project Status <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                placeHolder={PlaceHolder.SELECT_STATUS}
                                pageName="project"
                                dpDownName="projectstatus"
                                stateData={projectstatus}
                                controlName="prjStadrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "projectStatusId");
                                }}
                                value={prjStatus}
                                valueId={formValues?.projectStatusId}
                                setState={setprjStatus}
                              />
                              {formErrors?.projectStatusId && (
                                <p className="form-error">
                                  {formErrors?.projectStatusId}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Supervision Consultant
                              </label>
                              <DropDownComponent
                                placeHolder={formValues?.distributorId ? PlaceHolder.SELECT_SUPER_CONSULTANT : PlaceHolder.SHOULD_CHOOSE_FIELD("supervision consultant")}
                                pageName="project"
                                dpDownName="customer"
                                stateData={superCustomerDrp}
                                controlName="Supercustomerdrp"
                                handleChange={(e) => {
                                  HandleDropDownChange(e, "supervisionConsultantId");
                                }}
                                value={prjSuperCust}
                                valueId={formValues?.supervisionConsultantId}
                                setState={setprjSuperCust}
                                isDisabled={formValues?.distributorId ? false : true}
                              />
                              {formErrors?.supervisionConsultantId && (
                                <p className="form-error">
                                  {formErrors?.supervisionConsultantId}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Project Start Date <span className="mandatory">*</span>
                              </label>
                              <DatePicker
                                selected={prjStartDate}
                                onChange={(date) => setprjStartDate(date)}
                                customInput={<ExampleCustomInput />}
                                dayClassName={() => "example-datepicker-day-class"}
                                popperClassName="example-datepicker-class"
                                todayButton="TODAY"
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                              />
                              {formErrors?.startDate && (
                                <p className="form-error">{formErrors?.startDate}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>
                                Project End Date <span className="mandatory">*</span>
                              </label>
                              <DatePicker
                                selected={prjEndDate}
                                onChange={(date) => setprjEndDate(date)}
                                customInput={<ExampleCustomInput />}
                                dayClassName={() => "example-datepicker-day-class"}
                                popperClassName="example-datepicker-class"
                                todayButton="TODAY"
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                              />
                              {formErrors?.endDate && (
                                <p className="form-error">{formErrors?.endDate}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label>Additional info</label>
                              <textarea
                                className="form-control"
                                placeholder={PlaceHolder.ADDITIONAL_NOTES}
                                name="additionalInfo"
                                value={formValues?.additionalInfo}
                                onChange={HandleFormChange}
                                rows="5"
                              ></textarea>
                              {formErrors?.additionalInfo && (
                                <p className="form-error">{formErrors?.additionalInfo}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                     </div>
                     <div className="card sub-contractors-card mb-2">
                        <div className="card-header">
                          <h2>Additional Sub Contractors</h2>
                        </div>
                        <div className="card-body">
                          <div className="row additional-sub-contractors-row">
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <div className="text-right">
                                {formValues?.distributorId && (<button
                                  type="button"
                                  className="btn add-new-contractors-btn"
                                  onClick={ContractorOpen}
                                >
                                  <i class="fas fa-plus-square"></i> Add new MEP contractors
                                </button>)}
                              </div>
                            </div>
                            <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                              <div>
                                <label>MEP Contractor</label>
                                <DropDownComponent
                                  placeHolder={formValues?.distributorId ? PlaceHolder.SELECT_MEP_CUSTOMER : PlaceHolder.SHOULD_CHOOSE_FIELD("MEP Contractor")}
                                  pageName="project"
                                  dpDownName="customer"
                                  stateData={mepCustomerDrp}
                                  controlName="MEPcustomerdrp"
                                  handleChange={HandleMEPChange}
                                  value={addMEP}
                                  setState={setaddMEP}
                                  isDisabled={formValues?.distributorId ? false : true}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mt-3">
                              <div className="mt-14px">
                                <button
                                  type="button"
                                  className="btn add-btn"
                                  onClick={ConAddToList}
                                >
                                  Add to list
                                </button>
                              </div>
                            </div>
                            {addtoListMEP?.length > 0 && (
                              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 other-mep-contractors-table">
                                <table className="table table-striped table-borderless mt-3">
                                  <thead>
                                    <tr>
                                      <th scope="col">Sl#.</th>
                                      <th scope="col">Contractor name</th>
                                      <th scope="col" className="text-center"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {addtoListMEP?.map((item, index) => {
                                      return (
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>{item.label}</td>
                                          <td className="text-center">
                                            <span>
                                              <i
                                                className="far fa-trash-alt"
                                                onClick={() => {
                                                  ConDeleteToList(item.value);
                                                }}
                                                title="Delete"
                                              ></i>
                                            </span>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                     </div>
                    <ContactDetails
                    contact={contact}
                    setContactShow={setContactShow}
                    EditContact={EditContact}
                    deleteContact={deleteContact}
                  />
                  </div>
                </div>
                {!formValues?.id ? (
                  ""
                ) : (
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ display: "none" }}>
                    <div className="row">
                      <div className="col-md-12">
                        <div class="accordion" id="history">
                          <div class="card">
                            <div class="card-header" id="historyhead1">
                              <a
                                href="#"
                                class="btn btn-header-link"
                                data-toggle="collapse"
                                data-target="#history1"
                                aria-expanded="true"
                                aria-controls="history1"
                              >
                                History
                              </a>
                            </div>

                            <div
                              id="history1"
                              class="collapse"
                              aria-labelledby="historyhead1"
                              data-parent="#history"
                            >
                              <div class="card-body p-0">
                                <div className="history-table-sec">
                                  <table className="table table-striped table-borderless">
                                    <thead>
                                      <tr>
                                        <th scope="col" className="sort-icon pl-4">
                                          Date
                                        </th>
                                        <th scope="col">Time</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Description</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td className="text-align pl-4">05-May-2022</td>
                                        <td>10:15 Am</td>
                                        <td>Arun Gopalakrishnan</td>
                                        <td>Changed Phone number 4466091 to 4466095</td>
                                      </tr>
                                      <tr>
                                        <td className="text-align pl-4">05-May-2022</td>
                                        <td>10:15 Am</td>
                                        <td>Arun Gopalakrishnan</td>
                                        <td>Changed Phone number 4466091 to 4466095</td>
                                      </tr>
                                      <tr>
                                        <td className="text-align pl-4">05-May-2022</td>
                                        <td>10:15 Am</td>
                                        <td>Arun Gopalakrishnan</td>
                                        <td>Changed Phone number 4466091 to 4466095</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mt-4">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                    <div className="save-btns d-flex justify-content-end">
                      <button className="btn cancel-btn" onClick={ClearFormValues}>
                        Cancel
                      </button>
                      <button className="btn save-btn" onClick={HandleFormSubmit}>
                        {!formValues?.id ? "Save" : "Update"}
                      </button>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetails;
